import actions from './actions-category.js'
import mutations from './mutations-category.js'
import getters from './getters-category.js'
import state from './state-category.js'

export default {
    namespaced: true,
    actions,
    mutations,
    getters,
    state
}